import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Input } from 'antd';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';

const DropdownContainer = styled.div`
    border: 1px solid ${props => props.theme.LighterBorderColor};
    border-radius: 5px;
    position: absolute;
    z-index: 3000;
    width: 100%;
    box-shadow: 0 1px 6px rgba(57,73,76,.35);
`;

const Container = styled.div`
    position: relative;
`;

const Loading = styled.div`
    z-index: 3000;
`;

const Option = styled.div`
    padding: 4px 8px;
`;


const GoogleCities = ({ value, onChange }) => {
    const [address, setAddress] = useState('');
    const [editing, setEditing] = useState(false);
    // const [detailAddress, setDetailAddress] = useState();
    
    useEffect(() => {
        if (value) {
            setAddress(value.city);
        }
    }, [value]);

    const handleChange = address => {
        setAddress(address);
        onChange('');
        if (editing) {
            setEditing(false);
        }
    };
    
    const handleSelect = async selectedAddress => {
        const geoCode = await geocodeByAddress(selectedAddress);
        const { lat, lng } = await getLatLng(geoCode[0]);


        const componentForm = {
            street_number: 'short_name',
            route: 'long_name',
            locality: 'long_name',
            sublocality: 'long_name',
            administrative_area_level_1: 'long_name',
            country: 'long_name',
            postal_code: 'short_name'
        };
        let address = {};
        for (let i = 0; i < geoCode[0].address_components.length; i++) {
            const addressType = geoCode[0].address_components[i].types[0];
            if (componentForm[addressType]) {
                address[addressType] = geoCode[0].address_components[i][componentForm[addressType]];
            }
        }
        
        const data = {
            city: address.locality ? address.locality : '',
            lat: lat,
            lng: lng
        }
        onChange(data);
    };
    
    return (
        <>
            <PlacesAutocomplete
                value={address}
                onChange={handleChange}
                onSelect={handleSelect}
                searchOptions={{ types: ['(cities)'] }}
                // searchOptions={{types: ['locality']}}
            >
                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <Container>
                    <Input
                        autoComplete='off'
                        {...getInputProps({
                            placeholder: 'Search Places ...',
                            className: 'location-search-input',
                        })}
                    />
                    {suggestions.length > 0 && 
                        <DropdownContainer className="autocomplete-dropdown-container">
                            {loading ? <Loading>Loading...</Loading>
                            : suggestions.map(suggestion => {
                                const style = suggestion.active
                                ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                return (
                                    <Option
                                        {...getSuggestionItemProps(suggestion, {
                                            style,
                                        })}
                                    >
                                        <span>{suggestion.description}</span>
                                    </Option>
                                );
                            })}
                        </DropdownContainer>
                    }
                </Container>
                )}
            </PlacesAutocomplete>
        </>
    );
}

export default GoogleCities